import { globalCss, theme } from 'design-system';

export const addGlobalCss = globalCss({
  '@font-face': [
    {
      fontFamily: 'RobotoBold',
      src: `
      url('/fonts/roboto-bold-webfont.woff2') format('woff2'),
      url('/fonts/roboto-bold-webfont.woff') format('woff')
    `,
    },
    {
      fontFamily: 'RobotoRegular',
      src: `
      url('/fonts/roboto-regular-webfont.woff2') format('woff2'),
      url('/fonts/roboto-regular-webfont.woff') format('woff')
    `,
    },
  ],
  body: {
    backgroundColor: theme.colors.gray3,
    fontFamily: theme.fonts.sansSerif,
  },
});
